import { useProductContext } from '@/context/productContext';
import ImageWithFallback from '@/globalComponents/image';
import Div from '@/shared/Div';
import Header from '@/shared/Header';
import Paragraph from '@/shared/Paragraph';
import { getAddress } from '@/utils/address';
import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import ChevronIcon from '../Icons/Chevron';
import Span from '@/shared/Span';
import Button from '@/shared/Button';
import dynamic from 'next/dynamic';
import noop from '@/utils/noop';
import useScreen from '@/hooks/useScreen';

const DeviceSelectionModal = dynamic(() => import('../DeviceContainer/deviceSelectionModal'), {
  ssr: false,
});

type SelectedDeviceCardPropTypes = {
  className?: string;
  preventChangeDevice?: boolean;
  onDeviceChange?: () => void;
  isRescheduleJourney?: boolean;
};

function SelectedDeviceCard({
  className,
  preventChangeDevice,
  onDeviceChange,
  isRescheduleJourney = false,
}: SelectedDeviceCardPropTypes) {
  const { state: productState } = useProductContext();
  const [openDeviceModal, setDeviceModal] = useState<boolean>(false);

  const { selectedProduct, list } = productState;
  const { isDesktop, isTablet } = useScreen();
  const { img, name, address, id } = selectedProduct ?? {};
  const deviceId = useRef(id);
  const toggle = () => {
    setDeviceModal((s) => !s);
  };

  useEffect(() => {
    if (onDeviceChange && deviceId.current && deviceId.current !== id) {
      onDeviceChange();
    }
  }, [id]);

  return (
    <>
      <Div className={classNames('flex gap-s3 items-start justify-start', className)}>
        <Div className="w-10 h-10 md:w-16 md:h-16 flex-shrink-0 flex  items-center justify-center">
          <ImageWithFallback
            type="dynamic"
            src={img}
            height={40}
            width={40}
            alt={name}
            className="w-full h-full object-contain"
            data-testid="selected-device-image"
            fallbackSrc="/images/productPlaceholder.svg"
          />
        </Div>
        <Div style={{ width: `calc(100% - ${isDesktop || isTablet ? '80px' : '50px'})` }}>
          <Span
            className="flex gap-s2 items-center justify-between"
            onClick={preventChangeDevice ? noop : toggle}
          >
            <Header size="sm" className="truncate text-black/70">
              {name}
            </Header>
            {preventChangeDevice ? null : (
              <ChevronIcon size={20} className=" inline-block flex-shrink-0  md:hidden" />
            )}
          </Span>

          {address && (
            <Paragraph size="base" className="truncate text-black/50">
              {getAddress(address)}
            </Paragraph>
          )}

          {preventChangeDevice ? null : (
            <Button onClick={toggle} theme="link" className="mt-1 hidden md:block">
              Change Device
            </Button>
          )}
        </Div>
      </Div>
      <DeviceSelectionModal
        open={openDeviceModal}
        showConfirmButton
        products={list}
        onClose={toggle}
        isServiceFlow
        isServicePage
        isRescheduleJourney={isRescheduleJourney}
      />
    </>
  );
}

export default SelectedDeviceCard;
